module.exports = __webpack_public_path__ + "img/imagen3.4c9e6b33.png";